import { Tooltip } from 'antd';
import { debounce } from 'lodash';
import React, { useEffect, useMemo } from 'react';

import { FontSize, FormWrapper, NumberField, Select, Switch, Text, TextArea } from '../../../WidgetConfiguratorComponents/FormGroups';
import defaultState from '../defaultState';

const BasicSettingsConfigurator = (props) => {
    const { viewblockState, setViewblockState } = props;
    const { databilities, settings } = viewblockState;

    const truncateNowTo = settings.truncateNowTo || defaultState.settings.truncateNowTo;

    const onSettingsChange = (settings) => {
        setViewblockState((prev) => ({
            ...prev,
            settings: { ...prev.settings, ...settings },
        }));
    };

    const offsetLeft = typeof settings.offsetLeft === 'undefined' ? defaultState.settings.offsetLeft : settings.offsetLeft;

    return (
        <FormWrapper>
            <Text label='Title' value={settings.title} onChange={(title) => onSettingsChange({ title })} />
            <Text label='Subtitle' value={settings.subTitle} onChange={(subTitle) => onSettingsChange({ subTitle })} />

            <TextArea label='Description' value={settings.description} onChange={(description) => onSettingsChange({ description })} />

            <FontSize fontSize={settings.fontSize} onChange={(fontSize) => onSettingsChange({ fontSize })} />

            <Select
                label='Number of intervals'
                value={settings.timeStepsPerDay || defaultState.settings.timeStepsPerDay}
                onChange={(timeStepsPerDay) => onSettingsChange({ timeStepsPerDay: Math.round(timeStepsPerDay) })}
                values={[1, 2, 3, 4, 6, 8, 12, 24, 48, 96]}
            />
            <Tooltip
                title={
                    <div>
                        <div style={{ margin: '1em 0' }}>
                            Truncates the report time to the start of the current unit. 13:22:48 becomes:
                            <br />
                            <ul>
                                <li>
                                    <strong>Day:</strong> 00:00:00
                                </li>
                                <li>
                                    <strong>Hour:</strong> 13:00:00
                                </li>
                                <li>
                                    <strong>Minute:</strong> 13:22:00
                                </li>
                            </ul>
                            Affects the time range, so a time range of 0D -6H to 2D 12H generated on the 4th December at 13:22:48 becomes:
                            <ul>
                                <li>
                                    <strong>Day:</strong> 3rd Dec 18:00 to 6th Dec 12:00
                                </li>
                                <li>
                                    <strong>Hour:</strong> 4th Dec 13:00 to 7th 01:00
                                </li>
                                <li>
                                    <strong>Minute:</strong> 4th Dec 13:22 7th 01:22
                                </li>
                            </ul>
                        </div>
                    </div>
                }
            >
                <Select
                    label='Round "now" to start of'
                    value={truncateNowTo}
                    onChange={(newTruncateNowTo) => onSettingsChange({ truncateNowTo: newTruncateNowTo })}
                    values={['day', 'hour', 'minute']}
                />
            </Tooltip>

            <Text label='y-axis label' value={settings.yAxisLabel} onChange={(yAxisLabel) => onSettingsChange({ yAxisLabel })} />

            <Switch label='Use fixed offset' value={settings.useFixedOffset} onChange={(useFixedOffset) => onSettingsChange({ useFixedOffset })} />
            {settings.useFixedOffset && (
                <NumberField
                    label='Left offset'
                    value={offsetLeft}
                    onChange={(newOffsetLeft) => onSettingsChange({ offsetLeft: Math.round(newOffsetLeft) })}
                    step={1}
                />
            )}
            <Switch label='Full width legend' value={!!settings.legendFullWidth} onChange={(legendFullWidth) => onSettingsChange({ legendFullWidth })} />
            <Switch
                label='Enable xAxis Grid'
                value={typeof settings.enableXAxis === 'undefined' ? true : !!settings.enableXAxis}
                onChange={(enableXAxis) => onSettingsChange({ enableXAxis })}
            />
            <Switch
                label='Enable yAxis Grid'
                value={typeof settings.enableYAxis === 'undefined' ? true : !!settings.enableYAxis}
                onChange={(enableYAxis) => onSettingsChange({ enableYAxis })}
            />
            <Switch
                label='Enable "Now" line'
                value={typeof settings.enableNowLine === 'undefined' ? false : settings.enableNowLine}
                onChange={(enableNowLine) => onSettingsChange({ enableNowLine })}
            />
            <Text
                label='Enable "Now" line text'
                value={settings.enableNowLineText}
                disabled={!settings.enableNowLine}
                onChange={(enableNowLineText) => onSettingsChange({ enableNowLineText })}
            />
        </FormWrapper>
    );
};

export default BasicSettingsConfigurator;
